export const NoFiltersMatchMessage = () => {
  return <h3 style={{ padding: "4rem 1rem", textAlign: "center" }}>No products matched the filters</h3>;
};
